import { render } from "./AnotherHalfField.vue?vue&type=template&id=4e52d66a"
import script from "./AnotherHalfField.vue?vue&type=script&lang=js"
export * from "./AnotherHalfField.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__